var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pain-card card",class:'tone-' + _vm.tone,style:(_vm.toneStyle)},[_c('div',{staticClass:"pain-icon",class:'lk' + _vm.tone,domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }